<template>
  <div class="bp-data-table-field">
    <div class="d-flex gap-2" v-if="column.type == 'link'">
      <snow-button
        size="sm"
        icon="ph ph-link"
        variant="borderless"
        @click="copyLink"
      />
      <snow-button
        size="sm"
        icon="ph ph-arrow-square-out"
        variant="borderless"
        @click="openLink"
      />
    </div>

    <bp-tag
      v-else-if="column.type == 'tag'"
      :text="fieldValue"
      :color="getColor"
    />

    <popper-field v-else-if="column.type == 'popper'" :items="fieldValue" />

    <div v-else-if="truncate" class="field-value" :class="getClass">
      {{ fieldValue }}
      <span class="truncate-button" @click="() => (expand = !expand)">
        {{ expand ? "Ver menos" : "Ver mais" }}
      </span>
    </div>

    <div v-else class="field-value" :class="getClass">
      {{ fieldValue }}
    </div>
  </div>
</template>

<script>
import PopperField from "./PopperField.vue";
export default {
  components: {
    PopperField
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    column: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      expand: false
    };
  },
  computed: {
    truncate() {
      return this.column.limit && this.fieldValue.length > this.column.limit;
    },
    fieldValue() {
      const value = this.item[this.column.field];

      if (this.column.transform) return this.column.transform(value, this.item);

      if (
        this.column.limit &&
        !this.expand &&
        this.item[this.column.field].length > this.column.limit
      )
        return this.item[this.column.field].slice(0, this.column.limit) + "...";

      return this.item[this.column.field] ?? this.column.default ?? "-";
    },
    getClass() {
      if (typeof this.column.class == "function") {
        return this.column.class(this.item[this.column?.field], this.item);
      }

      return this.column.class;
    },
    getColor() {
      if (typeof this.column.color == "function") {
        return this.column.color(this.item[this.column?.field], this.item);
      }

      return this.column.color;
    }
  },
  methods: {
    copyLink() {
      navigator.clipboard.writeText(this.item[this.column.field]);
      this.$message.success("Link copiado.");
    },
    openLink() {
      window.open(this.item[this.column.field], "_blank");
    }
  }
};
</script>
<style lang="scss" scoped>
.bp-data-table-field {
  .field-value {
    font-size: 12px;
    line-height: 16px;
  }
  .truncate-button {
    cursor: pointer;
    color: $primary;
    font-size: 12px;
  }
}
</style>
